import { ConfigProvider, Form, Input, Modal, Typography } from "antd";
import { useSelector } from "react-redux";
const { Title } = Typography;
const ProfileModal = (props) => {
  const { isProfileModal, setIsProfileModal } = props;
  const authData = useSelector((state) => state.auth_store);
  console.log("Auth Data is :", authData);
  const dealer_code = authData?.defaultDealerCode;
  const currentDealer = authData?.dealer_codes.find(
    (dealer) => dealer.dealer_id === dealer_code
  );
  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: 8,
          },
        },
      }}
    >
      <Modal
        open={isProfileModal}
        onCancel={() => setIsProfileModal(false)}
        footer={false}
        centered
      >
        <Title level={2}>Profile Details</Title>
        <Form disabled layout="vertical">
          <Form.Item
            label="Company Name"
            name="company_name"
            initialValue={currentDealer?.company_name}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            initialValue={
              currentDealer?.address + ", " + currentDealer?.address2
            }
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="City"
            name="city"
            initialValue={currentDealer?.city}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="State"
            name="state"
            initialValue={currentDealer?.state}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Pin Code"
            name="pincode"
            initialValue={currentDealer?.pincode}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="GST Number"
            name="gst"
            initialValue={currentDealer?.gst}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </ConfigProvider>
  );
};

export default ProfileModal;
